import { Container } from '@material-ui/core';
import GlobalStyles from '@mui/material/GlobalStyles';
import clsx from 'clsx';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import * as Colors from 'src/theme/colors';

const loginPageGlobalStyles = {
  '*': {
    margin: 0,
    padding: 0,
  },
  html: {
    WebkitFontSmoothing: 'antialiased' as const,
    MozOsxFontSmoothing: 'grayscale' as const,
    height: '100%',
    width: '100%',
  },
  body: {
    height: '100%',
    width: '100%',
  },
  '#root': {
    height: '100%',
    width: '100%',
  },
};

const useStyles = makeStyles()((theme) => ({
  body: {
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
    minHeight: '100%',
    fontFamily: ['"Inter"', '"Helvetica"', '"Arial"', 'san-serif'].join(','),
    backgroundColor: Colors.white,
    ['@media screen and (min-height: 700px)']: {
      alignItems: 'center',
    },
  },
  container: {
    [theme.breakpoints.down('xs')]: {
      padding: 0,
      height: '100%',
    },
  },
}));

interface LoginPageLayoutProps {
  className?: string;
}

export const LoginPageLayout: React.FC<LoginPageLayoutProps> = ({
  children,
  className,
}) => {
  const { classes } = useStyles();

  return (
    <div className={clsx(classes.body, className)}>
      <GlobalStyles styles={loginPageGlobalStyles} />
      <Container className={classes.container} data-test-id="login-page-layout">
        {/* This is gross and ugly but the recommended approach for handling the TS error
         of React.Node is not assignable to NonNullable.. coming from MUI Container
         https://github.com/DefinitelyTyped/DefinitelyTyped/issues/18051#issuecomment-449628575 */}
        <>{children}</>
      </Container>
    </div>
  );
};
